import * as constants from './company-types'

export default {
  [constants.SET_COMPANIES_FULL_LIST] (state, payload) {
    state.companiesFullList = payload
  },
}
